
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPagination as ObcPaginationElement} from '@oicl/openbridge-webcomponents/dist/components/pagination/pagination.js';
 import {ObcPaginationValueChangeEvent, ObcPaginationNavigateEvent} from '@oicl/openbridge-webcomponents/dist/components/pagination/pagination.js';
 export type {ObcPaginationValueChangeEvent, ObcPaginationNavigateEvent} from '@oicl/openbridge-webcomponents/dist/components/pagination/pagination.js';
 

 
 export const ObcPagination = createComponent({
   react: React,
   tagName: 'obc-pagination',
   elementClass: ObcPaginationElement,
   events: {
     
     onValue: 'value' as EventName<ObcPaginationValueChangeEvent>,
     onNavigate: 'navigate' as EventName<ObcPaginationNavigateEvent>,
   }
  });
 
 